import axios from 'axios';
import { API_BASE_URL, IS_JOURNAL_MODE } from '../assets/const';
import { createNotification } from '../components/Notifications/Notifications';
import { checkAndUpdateToken, signOut } from '../actions/auth';

/**
 * Настраивает экземпляр Axios с базовым URL и перехватчиками.
 *
 * @param {object} store - Redux store.
 * @returns {object} - Конфигурированный экземпляр Axios.
 */
export const configureApi = (store) => {
  // Создание экземпляра Axios с базовым URL.
  const instance = axios.create({ baseURL: API_BASE_URL });

  // Перехватчик запросов: добавляет авторизационный заголовок, если токен существует.
  instance.interceptors.request.use(
    (config) => {
      // Проверяет и обновляет токен.
      store.dispatch(checkAndUpdateToken());

      // Получает токен и базу из Redux store.
      const { token, base } = store.getState().auth;

      if (token) {
        config.headers.Authorization = `Basic ${btoa(`nnz:${token}`)}`;
      }

      if (IS_JOURNAL_MODE && base) {
        config.headers['X-School-ID'] = base;
      }

      return config;
    },
    (error) => {
      // Обрабатывает ошибки запроса.
      return Promise.reject(error);
    }
  );

  // Перехватчик ответов: обрабатывает ошибки 401 (Unauthorized) и 503 (Service Unavailable).
  instance.interceptors.response.use(
    (response) => {
      // Возвращает успешный ответ.
      return response;
    },
    (error) => {
      // Обрабатывает ошибки ответа.
      if (error.message === 'Network Error') {
        // Сетевая ошибка (включая 504 Gateway Timeout без response).
        createNotification('error', `Превышено время ожидания ответа сервера`);
      } else if (error.response?.status === 401) {
        // Выходит из системы, если ответ 401.
        store.dispatch(signOut());
      } else if (error.response?.status === 503) {
        // Создает уведомление об ошибке, если ответ 503.
        createNotification('error', `Сервис временно недоступен`);
      } else if (error.response?.status === 504) {
        // Создает уведомление об ошибке, если ответ 504 (Gateway Timeout).
        createNotification('error', `Превышено время ожидания ответа сервера`);
      }
      // Возвращает отклонённый Promise для распространения ошибки.
      return Promise.reject(error);
    }
  );

  // Возвращает сконфигурированный экземпляр Axios.
  return instance;
};